<template>
  <v-divider :inset="inset" :vertical="vertical" :class="customClass" />
</template>

<script>
export default {
  name: 'CSDivider',
  props: {
    inset: {
      type: Boolean,
      required: false,
    },
    vertical: {
      type: Boolean,
      required: false,
    },
    customClass: {
      type: String,
      required: false,
    },
  },
}
</script>
